<template>
    <a-modal 
             :visible="isVisible"
             :closable="false"
             width="300px"
    >
        <template slot="footer">
            <a-button type="primary" @click="handleOK">
                Close
            </a-button>
        </template>
        <a-row type="flex" justify="start" class="icons-list">
             <a-col :flex="2">
               <!--  <a-icon :type="icon" /> -->
            </a-col>
        </a-row>

        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <template v-for="r in restaurants">
                    <a-button :key="r.restaurantId" @click="handleBtnSelect(r)" block shape="round">
                        {{ r.restaurantName }}
                    </a-button>
                    <a-divider type="horizontal"/>
                </template> 
            </a-col>
        </a-row>

    </a-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props : {
        message : String
    },
    computed : {
        ...mapState({
            restaurants : state => state.phoneService.restaurants
        })
    },
    data() {
        return {
            icon : 'loading',
            isVisible : false,
        }
    },
    methods : {

        handleOK() {
            this.isVisible = false;
        },
        handleBtnSelect(e) {
            this.$emit('selectedRestaurant', e);
            this.isVisible = false;
        },
        showModal() {
            this.isVisible = true;
        }
        
    },
    created() {
        this.isVisible = false;
    }
}
</script>

<style scoped>
</style>